export default __webpack_public_path__ + "static/style1.3_Andrey-82f60572e86c9f9ae44ca79509eefcd5.wav";